import React, { useEffect } from 'react'
import Sidebar from "../components/Sidebar";
import HeaderDashboard from "../components/Dashboard/HeaderDashboard";
import DashboardGridCards from "../components/Dashboard/DashboardGridCards";
import RecordTable from "../components/Dashboard/RecordTable";

const DashboardPage = () => {

  useEffect(() => {
    document.title = 'Dasbor - Admin Hi Nano';
  });

  return (
    <div className="flex min-h-screen bg-slate-100">
      <Sidebar />
      <div className="flex-1 p-10 ml-28">
        <HeaderDashboard />
        <DashboardGridCards />
        <RecordTable />
      </div>
    </div>
  )
}

export default DashboardPage